(function ($) {  
    function throttle(fn, threshold, scope) {
        threshold || (threshold = 250);
        var last,
            deferTimer;
        return function () {
            var context = scope || this;
        
            var now = +new Date,
                args = arguments;
            if (last && now < last + threshold) {
                // hold on to it
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
                }, threshold);
            } else {
                last = now;
                fn.apply(context, args);
            }
        };
    }

    var Menu = {

        /**
         * Responsive menu animations
         */
        sidebarCollapse: function () {
            $( "#sidebarCollapse" ).on( "click", function() {
                // open responsive menu
                $( ".navbar" ).toggleClass("active");
                $( this ).toggleClass("active");
            });
        }
    }

    var Page = {
        printPage: function () {
            $( document ).on( 'click', '#printPage', function (e) {
                e.preventDefault();
                window.print();
            });
        },

        displayBackToTopButton: function () {
            var anchor = $('.anchor');

            window.pageYOffset > 400 ? anchor.addClass('active') : '' ;
            window.addEventListener('scroll', 
                throttle(function () {
                    window.pageYOffset > 400 
                        ? anchor.addClass('active') 
                        : anchor.removeClass('active');
                }
            , 250));
        },

        /**
         * Animated scroll
         */
        animateScroll: function () {
            $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .not('[href*="#service"]')
            .click(function(event) {
                // On-page links
                if (
                location.pathname.replace(/^\//, "") ==
                    this.pathname.replace(/^\//, "") &&
                location.hostname == this.hostname
                ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length
                    ? target
                    : $("[name=" + this.hash.slice(1) + "]");
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $("html, body").animate(
                        {
                            scrollTop: target.offset().top
                        },
                        1000,
                        function() {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) {
                                // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                    }
                }
            });
        }
    }

    var Service = {
        
        /**
         * Responsive service list select
         */
        toggleSubservicesSelect: function () {
            $( document ).on( 'click', '.subservice__item', function(e) {
                // e.preventDefault();
                // e.stopPropagation();

                if( $( this ).hasClass('active') ) {
                    
                    $('.subservice__item:not(".active")').addClass('d-block');

                } else {

                    $('.subservice__item').removeClass('d-block');
                    $('.subservice__item.active').removeClass('active');
                    $(this).addClass('active');

                }
            });
        }, 
        
        /**
         * Services block transitions
         */
        toggleSubservicesArticles: function () {
            $( '.subservice__link' ).on( 'click', function(e) {
                // e.preventDefault();

                var parent = $( this ).parent();
                var content = $( this ).attr('href');

                if ( ! parent.hasClass( 'active' ) ) {
                    if($( '.subservice__article' ).hasClass('active')) {
                        $( '.subservice__article.active' ).fadeOut('150', 'easeInCubic');
                        $( '.subservice__article.active' ).promise().done(function() {
                            $( '.subservice__article.active' ).removeClass('active');
                            $( content ).addClass('active').fadeIn('150', 'easeOutCubic');
                            Count.start('.subservice__article.active .number__count.animate');
                        });
                    } else {
                        $( content ).addClass('active').slideDown('300', 'easeInQuad');
                        Count.start('.subservice__article.active .number__count.animate');
                    }
                }
            });
        },

        onloadSubservicesArticles: function () {
            var hash = window.location.hash;
            
            if ( hash.length ) {
                
                $('.subservice__item.active').removeClass('active');
                $('.subservice__link[href="' + hash + '"]').parent().addClass('active');

                $( '.subservice__article.active' ).fadeOut('150', 'easeInCubic');
                $( '.subservice__article.active' ).promise().done(function() {
                    $( '.subservice__article.active' ).removeClass('active');
                    $( hash ).addClass('active').fadeIn('150', 'easeOutCubic');
                    Count.start('.subservice__article.active .number__count.animate');

                    // if(window.scrollY != $(hash).offset().top - 50) {
                    //     $("html, body").animate(
                    //         {
                    //             scrollTop: $(hash).offset().top - 50
                    //         },
                    //         1000,
                    //         function() {
                    //             // Callback after animation
                    //             // Must change focus!
                    //             var $target = $(hash);
                    //             $target.focus();
                    //             if ($target.is(":focus")) {
                    //                 // Checking if the target was focused
                    //                 return false;
                    //             } else {
                    //                 $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                    //                 $target.focus(); // Set focus again
                    //             }
                    //         });
                    // }
                });
                
            }
        }
    }

    var Overlay = {

        openOverlay: function () {
            $( '[data-overlay]' ).on( 'click', function ( e ) {
                e.preventDefault();

                var target = $( this ).data('overlay');
                
                $(target).addClass('active').delay('50').queue(function() {
                    $(this).addClass("showing");
                    $(this).dequeue();
                });
                $( target ).find('.input--search').focus();
            });
        },

        closeOverlay: function () {
            $( document ).on( 'keydown', function ( e ) {
                if ( e.key === 'Escape' ) { // On 'ESC' keypress
                    $( '.overlay' ).removeClass('showing').delay('300').queue(function() {
                        $(this).removeClass("active");
                        $(this).dequeue();
                    });
                    Overlay.resetForm();
                }
            });

            $( document ).on( 'click', '.btn--close', function ( e ) {
                e.preventDefault();
                
                $( '.overlay' ).removeClass('showing').delay('300').queue(function() {
                    $(this).removeClass("active");
                    $(this).dequeue();
                });
                Overlay.resetForm();
            });
        },

        resetForm: function () {
            var form = $('.wpcf7-form')[0];
            
            if(form.length) {
                form.reset();
            }
        } 
    }

    var Count = {
        // start all the timers
        start: function ( element ) {
            $( element ).each(function() {
                $(this).countTo({
                    speed: 1200,
                    refreshInterval: 50,
                    formatter: function (value, options) {
                      return value.toFixed(options.decimals);
                    },
                    onUpdate: function (value) {
                      console.debug(this);
                    },
                    onComplete: function (value) {
                      console.debug(this);
                    }
                  });
            });  
        }
    }

    $( document ).ready( function () {   
        Service.onloadSubservicesArticles();
        Menu.sidebarCollapse();
        Page.printPage();
        Page.animateScroll();
        Service.toggleSubservicesSelect();
        Service.toggleSubservicesArticles();
        Overlay.openOverlay();
        Overlay.closeOverlay();
        Page.displayBackToTopButton();

        /**
         * News list categories filter
         */
        $('.news-cat-list select').on('change', function() {
            if ($(this).val() !== '') {
                window.location.href = $(this).val()
            }
        })

        /**
         * News ideas box
         */
        document.querySelectorAll('.ideas-box__toggle').forEach(function(toggle) {
            var form = toggle.nextElementSibling

            if (form !== null && form.classList.contains('ideas-box__form')) {
                toggle.addEventListener('click', function() {
                    form.classList.toggle('hidden')
                })
            }
        })
    });


     // CTA Modal
     const ctaModal = document.querySelectorAll('.cta__button');
     const modalClose = document.querySelectorAll('.modal__close-js');
     const modalBlock = document.querySelectorAll('.modal__block_cta');

     ctaModal.forEach(openElement => {
          openElement.addEventListener('click', event => {
               openElement.nextElementSibling.style.cssText  = 'bottom: 0; opacity: 1;';
          })
     })
     modalClose.forEach(btnCloseModal => {
          btnCloseModal.addEventListener('click', event => {
               modalBlock.forEach(closeElement => {
                    closeElement.style.removeProperty('bottom');
                    closeElement.style.removeProperty('opacity'); 
               })
          })
     })
// Easing animations
// t: current time, b: begInnIng value, c: change In value, d: duration
$.easing.jswing = $.easing.swing;

$.extend($.easing,
{
    def: 'easeOutQuad',
    easeInQuad: function (x, t, b, c, d) {
        return c*(t/=d)*t + b;
    },
    easeInCubic: function (x, t, b, c, d) {
        return c*(t/=d)*t*t + b;
    },
    easeOutCubic: function (x, t, b, c, d) {
        return c*((t=t/d-1)*t*t + 1) + b;
    }
});
})(jQuery);